// import "./Modal.css";
import React, { useState, useEffect, useContext, useRef } from "react";

import {
  ModalBackground,
  ModalButtons,
  ModalConteiner,
  ModalFooter,
  ModalHeader,
  ModalHeaderConteiner,
  ModalHeaderCross,
  ModalHeaderCrossX,
  ModalHeaderCrossY,
  ModalHeaderTitle,
} from "./localStyle";

import { GlobalContext } from "../../../context/Provider";
import { hideModal } from "../../../context/action/modal/modal";

const Modal = () => {
  const { modalState, modalDispatch } = useContext(GlobalContext);
  const [animation, setAnimation] = useState("");
  const [flgComponent, setFlgComponet] = useState(false);
  const [listBotones, setListBotones] = useState([]);
  const [posicion, setPosicion] = useState(["centro"]);
  const [bloquearDissmiss, setBloquearDissmiss] = useState(true);
  // Hook estable para mantener el orden de hooks entre renders (previene warning de React Hooks)
  const stableRef = useRef(null);

  const dissmiss = () => {
    if (!bloquearDissmiss) {
      setAnimation("");
      hideModal()(modalDispatch);
    }
  };

  const preventDissmiss = (event) => {
    event.stopPropagation();
  };

  useEffect(() => {
    if (flgComponent) {
      setFlgComponet(false);
      setBloquearDissmiss(modalState.modal?.data?.bloquearDissmiss ?? true);
    }
  }, [flgComponent]);

  useEffect(() => {
    const data = modalState.modal?.data;
    if (!data) return;
    if (
      data.posicion !== undefined &&
      data.posicion !== null &&
      data.posicion !== ""
    ) {
      setPosicion(data.posicion);
    }
    setFlgComponet(true);
    if (Array.isArray(data.listBotones)) {
      setListBotones(data.listBotones);
    } else {
      setListBotones([]);
    }
  }, []);

  return (
    <React.Fragment>
      <ModalBackground onClick={dissmiss}>
        <ModalConteiner onClick={preventDissmiss}>
          <ModalHeaderConteiner
            className={`${
              modalState.modal?.data?.headerState ? "bgcG-danger" : "bgcG-latex30"
            }`}
          >
            <ModalHeaderTitle>
              {modalState.modal?.data?.title === "" || !modalState.modal?.data?.title
                ? "Error en el sistema"
                : modalState.modal.data.title}
            </ModalHeaderTitle>
            <ModalHeaderCross onClick={modalState.modal?.data?.dissmiss}>
              <ModalHeaderCrossX></ModalHeaderCrossX>
              <ModalHeaderCrossY></ModalHeaderCrossY>
            </ModalHeaderCross>
          </ModalHeaderConteiner>
          {modalState.modal?.data?.component !== null &&
            modalState.modal?.data?.params !== null &&
            modalState.modal?.data?.component}
          {Array.isArray(listBotones) && listBotones.length > 0 && (
            <ModalFooter>
              {listBotones.map((item, i) => {
                return (
                  <ModalButtons
                    className={item.clase}
                    onClick={item.accion}
                    key={i}
                  >
                    {item.text}
                  </ModalButtons>
                );
              })}
            </ModalFooter>
          )}
        </ModalConteiner>
      </ModalBackground>
    </React.Fragment>
  );
};
export default Modal;
